import React, { ComponentProps, memo } from 'react'

import escape from 'escape-html'

import { Text } from './Text'

interface HighlightedTextProps extends ComponentProps<typeof Text> {
  value: string
  search?: string
}

// to convert &quot; and similar characters
const decodeHTMLEntities = (text: string) => {
  const textarea = document.createElement('textarea')
  textarea.innerHTML = text

  return textarea.value
}

const escapeRegExp = (text: string) =>
  text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const HighlightedText = memo(
  ({
    value,
    search,
    variant = 'primary',
    bold = false,
    ...rest
  }: HighlightedTextProps) => {
    const sanitizedValue = escape(value)
    const sanitizedSearch = escape(search)
    const escapedSearch = escapeRegExp(sanitizedSearch)

    // We can rely on React's automatic escaping
    if (search === '') {
      return <Text {...{ bold, ...rest }}>{value}</Text>
    }

    return (
      <Text {...{ bold, ...rest }}>
        {sanitizedValue
          // eslint-disable-next-line security/detect-non-literal-regexp
          ?.split(new RegExp(`(${escapedSearch})`, 'gi'))
          .map((part, index) =>
            part.toLowerCase() === sanitizedSearch.toLowerCase() ? (
              <Text
                key={index}
                {...{ variant, fz: 'inherit', lh: 'inherit', fw: 'inherit' }}>
                {decodeHTMLEntities(part)}
              </Text>
            ) : (
              decodeHTMLEntities(part)
            ),
          )}
      </Text>
    )
  },
)
